import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  Modal,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  ModalDrawerButtonStyles,
  ModalDrawerStyles,
  ModalHeader,
} from "../../../../Common/styles/modal";
import { useAppDispatch } from "../../../../../Redux/hooks";
import { setShowModal } from "../../../../../Redux/reducers/appCustomizationSlice";
import { errorToastMessage, toastMessage } from "../../../../../utils/toast";
import { DrawerForm } from "./../../../../Common/styles/drawer";
import {
  StyledTableCell,
  TableBorderRadiusTopLeftRight,
} from "../../../../Common/styles/table";
import { RadioButtonChecked, RadioButtonUnchecked } from "@mui/icons-material";

const urls = [
  {
    id: 1,
    url: "https://google.com",
  },
  {
    id: 2,
    url: "https://google1.com",
  },
  {
    id: 3,
    url: "https://google2.com",
  },
  {
    id: 4,
    url: "https://google3.com",
  },
];

type Props = {
  index: string;
  handleFieldChange: Function;
};

const SelectCustomUrl = ({ index, handleFieldChange }: Props) => {
  const [url, setUrl] = useState<string>("");
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const closeModal = () => {
    dispatch(setShowModal(false));
  };

  const submitHandler = async () => {
    try {
      if (!url.trim()) {
        toastMessage("error", "URL is required");
        return;
      }
      handleFieldChange(index, "connector", url);
      setSubmitLoader(true);
      console.log(url);
      closeModal();
    } catch (e) {
      errorToastMessage(e as Error);
    } finally {
      setSubmitLoader(false);
    }
  };

  const handleCheckboxToggle = (key: string) => {
    if (url === key) {
      setUrl("");
    } else {
      setUrl(key);
    }
  };

  return (
    <Modal open={true} onClose={closeModal}>
      <Box sx={ModalDrawerStyles}>
        <ModalHeader title={"Select URL"} onCloseClick={closeModal} />
        <Box sx={DrawerForm}>
          <Box>
            <Table sx={TableBorderRadiusTopLeftRight}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>URL Name</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {urls?.map((item: any) => (
                  <TableRow key={item?.id}>
                    <StyledTableCell>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                      >
                        <Checkbox
                          checked={url === item?.url}
                          icon={<RadioButtonUnchecked />}
                          onChange={() => handleCheckboxToggle(item?.url)}
                          checkedIcon={<RadioButtonChecked />}
                        />
                        <Typography variant="subtitle1" fontWeight={500}>
                          {item?.url}
                        </Typography>
                      </Box>
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
          <Box sx={{ mt: "auto" }}>
            <Divider />
            <Box sx={ModalDrawerButtonStyles}>
              {!submitLoader ? (
                <>
                  <Button variant="outlined" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={!url}
                    onClick={submitHandler}
                  >
                    Save
                  </Button>
                </>
              ) : (
                <CircularProgress size={25} />
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default SelectCustomUrl;
